import { DateTimeHelper } from '@absg/angular-platform';
import {
  AbstractControl,
  UntypedFormControl,
  ValidatorFn,
} from '@angular/forms';

export const regExpValidators = {
  WholeNumberValidator: new RegExp(/^[0-9]*$/),
  WholeNumberValidator6: new RegExp(/^\d{0,6}$/),
  WholeNumberValidator7: new RegExp(/^\d{0,7}$/),
  WholeNumberValidator9: new RegExp(/^\d{0,9}$/),
  DecimalNumberValidatorWithPrecision4: new RegExp(/^[0-9]*\.?[0-9]{1,4}$/),
  DecimalNumberValidator6_4: new RegExp(/^\d{0,6}(\.\d{0,4})?$/),
  DecimalNumberValidator7_4: new RegExp(/^\d{0,7}(\.\d{0,4})?$/),
  DecimalNumberValidator9_4: new RegExp(/^\d{0,9}(\.\d{0,4})?$/),
  AlphaNumeric: new RegExp(/^[A-Za-z0-9]*$/),
  NdcCode: new RegExp(/^\d{5}-\d{4}-\d{2}$/),
  AlphaNumericWithSpecialChars: new RegExp(/^[ A-Za-z0-9_@./#&!():;$%^*<>+-]*$/),
  AllCharsExceptSomeSpecialChars: new RegExp(/^[^<>[\]]*$/),
};

export abstract class ValidationHelpers {
  static required(control: UntypedFormControl): Record<string, boolean> {
    if ((control.value || '').trim().length === 0) {
      return { validationError: true };
    }
  }

  static alphaNumericValidator(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !String(control.value).match(regExpValidators.AlphaNumeric)) {
      return { validationError: true };
    }
  }

  static alphaNumericValidatorWithSpecialChars(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !String(control.value).match(regExpValidators.AlphaNumericWithSpecialChars)) {
      return { validationError: true };
    }
  }

  static allCharsExceptSomeSpecialChars(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !String(control.value).match(regExpValidators.AllCharsExceptSomeSpecialChars)) {
      return { validationError: true };
    }
  }

  static wholeNumberValidator(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !String(control.value).match(regExpValidators.WholeNumberValidator)) {
      return { validationError: true };
    }
  }

  static wholeNumberValidator6(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !regExpValidators.WholeNumberValidator6.test(control.value)) {
      return { validationError: true };
    }
  }

  static decimalNumberValidatorWithPrecision4(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !regExpValidators.DecimalNumberValidatorWithPrecision4.test(control.value)) {
      return { validationError: true };
    }
  }

  static decimalNumberValidator6_4(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !regExpValidators.DecimalNumberValidator6_4.test(control.value)) {
      return { validationError: true };
    }
  }

  static decimalNumberValidator7_4(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !regExpValidators.DecimalNumberValidator7_4.test(control.value)) {
      return { validationError: true };
    }
  }

  static decimalNumberValidator9_4(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !regExpValidators.DecimalNumberValidator9_4.test(control.value)) {
      return { validationError: true };
    }
  }

  static minMaxNumberValidator(minValue: number, maxValue: number): ValidatorFn {
    return (c: AbstractControl): Record<string, boolean> | null => {
      if (c.value != null) {
        if (minValue != null && maxValue != null && (c.value < minValue || c.value > maxValue)) {
          return { validationError: true };
        } else if (minValue != null && c.value < minValue) {
          return { validationError: true };
        } else if (maxValue != null && c.value > maxValue) {
          return { validationError: true };
        }
      }
    };
  }

  static isDigit(digit: string): boolean {
    const digits = new RegExp('[0-9]');
    return !!digit && digit.length === 1 && digits.test(digit);
  }

  static ndcValidator(control: UntypedFormControl): Record<string, boolean> {
    if (control.value && !String(control.value).match(regExpValidators.NdcCode)) {
      return { validationError: true };
    }
  }

  static greaterThanValidator(minValue: number): ValidatorFn {
    return (c: AbstractControl): Record<string, boolean> | null => {
      if (c.value != null && c.value !== '') {
        if (minValue != null && c.value <= minValue) {
          return { validationError: true };
        }
      }
    };
  }

  static maxNumberValidator(maxValue: number): ValidatorFn {
    return (c: AbstractControl): Record<string, boolean> | null => {
      if (c.value) {
        if (maxValue && c.value > maxValue) {
          return { validationError: true };
        }
      }
    };
  }

  static dateInputValidator(control: UntypedFormControl): Record<string, boolean> {
    if (control.value != null && control.value !== '') {
      if (control.value.length === 10) {
        if (!DateTimeHelper.isDateStringValid(control.value)) {
          return { validationError: true };
        }
      } else {
        return { validationError: true };
      }
    }
  }
}
